






import Vue from 'vue';
import Tooltip from '@/components/Tooltip.vue';

export default Vue.extend({
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
});
